// يفتح مخالصة نهاية الخدمة في نافذة طباعة بهوية الشركة (طباعة المتصفح تُنتج الـPDF).
import { css } from "./reportTokens";
import { brandLogo, brandName } from "./reportBrand";
import { printButton } from "../reports/reportButtons";
import { esc, formatCurrency, today } from "./reportFormat";
import { S } from "./settlementLabels";

const row = (label, value, net = false) =>
  `<tr class="${net ? "net" : ""}"><td>${esc(label)}</td><td class="amt">${esc(value)}</td></tr>`;

const signBlock = (L) =>
  `<div class="sign"><div class="sign-row">${L.signRoles
    .map((r) => `<div class="sign-box"><div class="sign-role">${esc(r)}</div><div class="sign-line"></div></div>`)
    .join("")}</div></div>`;

const body = (data, L, c) =>
  data.exit_type === "dismissal"
    ? `<div class="warn"><div class="title">${esc(L.legalTitle)}</div>${esc(L.legalNote)}</div>`
    : `<table class="settle"><tbody>
    ${row(L.rows.basic, formatCurrency(data.basic_salary, c))}
    ${row(L.rows.hire, data.hire_date)}
    ${row(L.rows.last, data.last_working_day)}
    ${row(L.rows.years, data.years_of_service)}
    ${row(L.rows.accrued, formatCurrency(data.accrued_salary, c))}
    ${row(L.rows.gratuity, formatCurrency(data.gratuity, c))}
    ${row(L.rows.deductions, "-" + formatCurrency(data.deductions, c))}
    ${row(L.rows.net, formatCurrency(data.net_amount, c), true)}
  </tbody></table>
  <div class="explain">${esc(L.gratuityNote)}</div>`;

const SCRIPT = `<script>
function reportPrint(){document.body.classList.add('exporting');window.print();setTimeout(function(){document.body.classList.remove('exporting')},400);}
function reportClose(){window.close();}
<\/script>`;

export const openSettlementReport = (data, brand, lang = "ar") => {
  const L = S[lang === "en" ? "en" : "ar"];
  const rtl = lang !== "en";
  const c = data.currency;
  const name = rtl && data.name_ar ? data.name_ar : data.user_name;
  const reason = L.exitTypes[data.exit_type || data.reason] || L.reasons[data.reason] || data.reason || "";
  const win = window.open("", "_blank");
  if (!win) return false;
  const html = `<!DOCTYPE html>
<html lang="${rtl ? "ar" : "en"}" dir="${rtl ? "rtl" : "ltr"}">
<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">
<title>${esc(L.pdfTitle)}</title><style>${css(false)}
  .settle{width:100%;max-width:640px;margin:0 auto;border:1px solid #dee2e6;border-radius:8px;overflow:hidden}
  .settle td{padding:11px 14px;border-bottom:1px solid #dee2e6;font-size:13px;font-weight:700}
  .settle td.amt{text-align:end;font-family:monospace}
  .settle tr.net td{background:#1e3a2f;color:#fff;font-size:16px;font-weight:900;border:0}
  .sign-line{border-bottom:1px solid #999;height:34px;margin:6px 6px 0}
</style></head>
<body>
  <div class="print-buttons">${printButton(L)}<button class="btn-close" data-testid="settlement-close" onclick="reportClose()">${esc(L.close)}</button></div>
  <div class="header">${brandLogo(brand)}${brandName(brand)}
    <h1>${esc(L.pdfTitle)}</h1><h2>${esc(name || "")}</h2>
    <p>${esc([data.job_title, data.branch_name].filter(Boolean).join(" · "))}</p>
    <p class="period">${esc(reason)}</p>
    <p>${esc(L.generatedAt)}: ${today()}</p></div>
  ${body(data, L, c)}
  ${signBlock(L)}
  ${SCRIPT}
</body></html>`;
  win.document.open();
  win.document.write(html);
  win.document.close();
  return true;
};
